import { Box, CircularProgress, Divider, Stack } from '@mui/material'
import DisplayErrorPopup from '../DisplayError'
import CustomDialog from '../CustomDialog'
import React from 'react'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { Can } from '../../utils/AbilityUtil'
import OrganizationInfoComponent from '../Organization/OrganizationInfoComponent'
import AssignEngineerComponent from './AssignEngineerComponent'

interface AssignProjectProps {
  isOpen: boolean
  isLoading: boolean
  handleClose: () => void
}

const AssignProjectComponent: React.FC<AssignProjectProps> = ({
  isOpen,
  handleClose,
  isLoading,
}) => {
  return (
    <Can I={AttributeActionNames.Assign} a={AttributeResourceNames.Tasks}>
      <CustomDialog
        isOpen={isOpen}
        title='Assign Project'
        hideActions={true}
        handleClose={handleClose}
      >
        <DisplayErrorPopup />
        <Stack
          gap={'20px'}
          sx={{
            height: '677px',
            width: '540px',
            boxSizing: 'border-box',
            mt: '10px',
          }}
        >
          {!isLoading ? (
            <>
              <Divider flexItem />
              <OrganizationInfoComponent />
              <Divider flexItem />
              <AssignEngineerComponent />
            </>
          ) : (
            <Box
              sx={{
                height: '100%',
                width: '100',
                justifyContent: 'center',
                justifyItems: 'center',
                alignContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Stack>
      </CustomDialog>
    </Can>
  )
}

export default AssignProjectComponent
